import Button from '@material-ui/core/Button';
import { GA_EVENT_TREE } from '../../../../gaConstants';
import React from 'react';
import GoogleClassroomIcon from '../../../../MyComponents/icons/GoogleClassroomIcon';

export const GoogleClassroomLoginButton = ({ handleLogin, classes }) => {
    return (
        <div style={{ paddingLeft: '1.5rem' }}>
            {!window.isTeams ? (
                <Button
                    size="large"
                    variant="contained"
                    className={classes.loginButtonSmall}
                    onClick={() => {
                        window.logAppActivity(GA_EVENT_TREE.mainPage.links.googleLogin);
                        handleLogin('/google');
                    }}
                    startIcon={<GoogleClassroomIcon className={classes.customIcon} />}
                />
            ) : null}
        </div>
    );
};
